import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import Scorecard from "./scorecard";
import CondoPieChart from "./occupancyPieMobile";
import EditPropertyForm from "../../forms/editPropertyForm";

import { Autocomplete, TextField, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const MobileDashboard = ({
    userData,
    propertiesData,
    unitsData,
    selectedProperty,
    onPropertyChange,
}) => {
    const [images, setImages] = useState([]);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const queryClient = useQueryClient();

    const user = userData.user.userData.givenName;
    const userName = user && user.charAt(0).toUpperCase() + user.slice(1);

    useEffect(() => {
        if (selectedProperty.images && selectedProperty.images.length > 0) {
            setImages(selectedProperty.images);
        } else {
            setImages([]); // ensure it resets when no images
        }
    }, [selectedProperty]);

    return (
        <>
            <div className="relative flex flex-col items-center mb-4">
                {images.length > 0 ? (
                    images.map((photo) => (
                        <img
                            key={photo._id}
                            src={photo.key}
                            alt={photo.altText || "Property Photo"}
                            className="rounded-[15px] h-[150px] md:h-[200px] w-full object-cover"
                        />
                    ))
                ) : (
                    null
                )}
                <IconButton
                    aria-label="edit"
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 20,
                        right: 20,
                        backgroundColor: "rgba(255,255,255,0.8)",
                        "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                        boxShadow: 1,
                    }}
                    onClick={() => setIsEditOpen(true)}
                >
                    <EditIcon />
                </IconButton>
            </div>
            <div className="flex flex-col items-center bg-[#445485] mb-4 rounded-[15px]">
                <div className="flex flex-col items-center px-6 pt-6 w-full">
                    <div className="welcome-box-text text-center">
                        <h1>Welcome back, {userName}!</h1>
                        <p>This is your property portfolio for the month.</p>
                    </div>
                </div>
                <div className="welcome-box-stats" style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingBottom: "20px" }}>
                    <Autocomplete
                        options={propertiesData || []}
                        value={selectedProperty || null}
                        onChange={(e, newVal) => onPropertyChange(newVal)}
                        isOptionEqualToValue={(option, value) => option?._id === value?._id}
                        getOptionLabel={(option) => option?.name || ""}
                        renderInput={params => (
                            <TextField {...params}
                                variant="outlined"
                                sx={{
                                    backgroundColor: '#fff',
                                    borderRadius: '9.5px',
                                    width: '320px',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '9.5px',
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: '#888',
                                    },
                                }} />
                        )}
                        sx={{ width: "100%" }} />
                    <Scorecard data={unitsData} />
                    <CondoPieChart data={unitsData} />
                </div>
            </div>

            {isEditOpen && (
                <EditPropertyForm
                    property={selectedProperty}
                    propertyId={selectedProperty?._id}
                    onClose={() => setIsEditOpen(false)}
                    onPropertyUpdated={(updatedProperty) => {
                        queryClient.invalidateQueries(["v2-properties"]);
                        onPropertyChange(updatedProperty);
                        setIsEditOpen(false);
                    }}
                />
            )}
        </>
    );
};

export default MobileDashboard;
